<ng-container *ngFor="let item of listItems; let i = index">
  <div
    class="form-group form-container pb-2 pr-2"
    [id]="item.id"
    (click)="onClickListner(item.id)"
    [class.hidden]="
      item?.entityType === CONSTANTS.ACCESS_POINT && !commonAccessControl
    "
  >
    <div class="d-flex list-view">
      <ng-container
        *ngIf="
          item?.entityType === CONSTANTS.ACCESS_POINT && commonAccessControl
        "
      >
        <div class="d-flex col-4">
          <span>
            <img
              [src]="
                '/assets/svg/' +
                (item.activationState
                  | deviceStatusPipe
                    : item.batteryPercentage
                    : item.deviceStatus
                    : item.unitName)
              "
              alt="ico-building-with-black-circle"
              class="left-icon"
            />
          </span>
          <div class="pl-3 align-self-center" *ngIf="item?.entityName">
            <div class="list-title bold pb-1 overflow-ellipsis">
              <app-profile-tooltip [showHelpCursor]="true">
                {{ item?.entityName }}
              </app-profile-tooltip>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="item?.entityType === CONSTANTS.LOCK">
        <div class="d-flex col-4">
          <span>
            <img
              [src]="
                '/assets/svg/' +
                (item.activationState
                  | deviceStatusPipe
                    : item.batteryPercentage
                    : item.deviceStatus
                    : item.unitName)
              "
              alt="ico-building-with-black-circle"
              class="left-icon"
            />
          </span>
          <div class="pl-3 align-self-center" *ngIf="item?.entityName">
            <div class="list-title bold pb-1 overflow-ellipsis">
              <app-profile-tooltip [showHelpCursor]="true">
                {{ item?.entityName }}
              </app-profile-tooltip>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="col-4 align-self-center">
        <div class="detail-name pb-1 ml-5">
          <ng-container *ngIf="item?.unitName">
            <div class="text-nowrap overflow-ellipsis">
              <app-profile-tooltip [showHelpCursor]="true">
                {{ "UNIT" | translate }} {{ item?.unitName }},
                {{ item.buildingName }}
                {{
                  userType === CONSTANTS.RESIDENT
                    ? " -" + (accessLevelResponse[item.accessLevel] | translate)
                    : ""
                }}
              </app-profile-tooltip>
            </div>
          </ng-container>
          <ng-container *ngIf="!item?.unitName && commonAccessControl">
            <app-profile-tooltip [showHelpCursor]="true">
              {{ item.buildingName }}
              {{
                userType === CONSTANTS.RESIDENT
                  ? " -" + (accessLevelResponse[item.accessLevel] | translate)
                  : ""
              }}
            </app-profile-tooltip>
          </ng-container>
        </div>
      </div>
      <div class="col-4 align-self-center">
        <ng-container
          *ngIf="
            item?.entityType === CONSTANTS.ACCESS_POINT && commonAccessControl
          "
        >
          <div class="w-100 text-right">
            <div class="detail-name pb-1 ml-5">
              <div class="d-flex">
                <div class="col-11">
                  <span *ngIf="item?.expireTime">
                    <span class="bold">
                      <app-profile-tooltip [showHelpCursor]="true">
                        {{ getDate(item?.startTime) }} {{ "TO" | translate }}
                        {{ getDate(item?.expireTime) }}
                      </app-profile-tooltip>
                    </span>
                  </span>
                  <ng-container *ngIf="item?.repeatDays && !item?.expireTime">
                    <div class="bold">
                      <app-profile-tooltip [showHelpCursor]="true">
                        {{ splitIntoComma(item) }}
                      </app-profile-tooltip>
                    </div>
                  </ng-container>
                </div>
                <div class="col-1">
                  <span class="forword-arrow">
                    <img src="assets/svg/ico-chevron-forward-outline.svg" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="item?.entityType === CONSTANTS.LOCK">
          <div class="w-100 text-right">
            <div class="detail-name pb-1 ml-5">
              <div class="d-flex">
                <div class="col-11">
                  <span *ngIf="item?.expireTime">
                    <span class="bold">
                      <app-profile-tooltip [showHelpCursor]="true">
                        {{ getDate(item?.startTime) }} {{ "TO" | translate }}
                        {{ getDate(item?.expireTime) }}
                      </app-profile-tooltip>
                    </span>
                  </span>
                  <ng-container *ngIf="item?.repeatDays && !item?.expireTime">
                    <div class="bold">
                      <app-profile-tooltip [showHelpCursor]="true">
                        {{ splitIntoComma(item) }}
                      </app-profile-tooltip>
                    </div>
                  </ng-container>
                </div>
                <div class="col-1">
                  <span class="forword-arrow">
                    <img src="assets/svg/ico-chevron-forward-outline.svg" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
